module.exports = __webpack_public_path__ + "bin/59d748bb660d4becbc53b9bd0838a4aa.svg";